import React from "react";
import { GiftCardDetailsPage } from "../../Components/dashboard";

const OrgGiftCardDetails = () => {
  return <GiftCardDetailsPage role="creator" />;
};

export default OrgGiftCardDetails;
